import { useMemo } from "react";
import {
  useExcludedWorkflowKindTags,
  usePreSelectedWorkflowKindTags
} from "./usePreSelectedWorkflowKinds";
import type { Kind } from "@certa/types";

export const useGetKindOptions = (kindsList?: Kind[]) => {
  const excludedWorkflowKindTags = useExcludedWorkflowKindTags();
  const preSelectedKindTags = usePreSelectedWorkflowKindTags();

  return useMemo(() => {
    const kindOptions = kindsList
      ? kindsList
          .filter(kind => !excludedWorkflowKindTags.includes(kind.tag))
          .map(({ name, id, tag }) => ({
            label: name,
            value: String(id),
            isPreSelected: preSelectedKindTags.includes(tag)
          }))
          .sort((a, b) => {
            // Sort preselected items to the top
            if (a.isPreSelected && !b.isPreSelected) return -1;
            if (!a.isPreSelected && b.isPreSelected) return 1;
            // For items with same preselected status, maintain alphabetical order
            return a.label.localeCompare(b.label);
          })
      : [];

    return kindOptions;
  }, [kindsList, excludedWorkflowKindTags, preSelectedKindTags]);
};
